import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { useQueryClient } from 'react-query';
import { mutations } from 'RestAPIs/rapini';

const useCreateDayLimitArrangement = () => {
  const queryClient = useQueryClient();
  return mutations.useCreateDayLimitArrangement({
    onSuccess: async () => {
      showSuccessSnackbar();
      await queryClient.invalidateQueries(['dayLimitArrangements', 'list']);
    },
    onError: () => {
      showErrorSnackbar();
    }
  });
};

export default useCreateDayLimitArrangement;
